export enum Y42Routes {
  Default = 'integrations',
  Integration = 'integrations',
  Modeling = 'models',
  SqlModeling = 'models/sql',
  UiModeling = 'models/ui',
  Orchestration = 'orchestrations',
  Editor = 'editor',
  Visualization = 'visualizations',
  VisualizationDashboard = 'visualizations/dashboards',
  VisualizationWidget = 'visualizations/widgets',
  VisualizationFilter = 'visualizations/filters',
  VisualizationTheme = 'visualizations/theme',
  Export = 'exports',
  Profile = 'profile',
  Alert = 'alerts',
  AlertStatusAlert = 'alerts/status-alerts',
  Lineage = 'lineage',
  Catalog = 'catalog',
}

export type Y42Route = `${Y42Routes}`;

export enum Y42RouteDetailTabs {
  Default = 'overview',
  Overview = 'overview',
  Structure = 'structure',
  Data = 'data',
}

export type Y42RouteDetailTab = `${Y42RouteDetailTabs}`;

export interface EditorRouteData {
  code: true;
}
